import React, { useState, ReactNode, useEffect } from 'react';
import { isIOSDevice, FLOATING_CONFIGS, updateFloatingElements, KeyboardContext } from './keyboardUtils';

// ============================================================================
// PROVIDER
// ============================================================================

export const KeyboardProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  // Update CSS variable and floating elements on keyboard height change
  useEffect(() => {
    document.documentElement.style.setProperty('--keyboard-height', `${keyboardHeight}px`);

    if (isIOSDevice()) {
      const floatingConfigs = Object.values(FLOATING_CONFIGS);
      updateFloatingElements(floatingConfigs, keyboardHeight);
    }
  }, [keyboardHeight]);

  return (
    <KeyboardContext.Provider value={{ keyboardHeight, setKeyboardHeight }}>
      {children}
    </KeyboardContext.Provider>
  );
};
